export type DateInput = ConstructorParameters<DateConstructor>[0];

/**
 * Converts the input into a unix timestamp.
 * If the input to date conversion process cannot be completed, a NaN (Not a Number) is returned.
 * While it is technically a number, this should be handled appropriately by the caller.
 *
 * @param {DateInput} dateInput any valid date constructor input to be converted into a timestamp
 * @returns {number} a number representing milliseconds since the epoch (unix timestamp)
 */
export const dateToTimestamp = (dateInput: DateInput) => {
  return new Date(dateInput).getTime();
};
